import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { compiledVersion } from '../../compiled-version';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class LoggerService {
    constructor(private http: HttpClient) {}

    logError(error) {
        try {
            const errorPayload = typeof error === 'string' ? error : JSON.stringify(error);
            this.sendData(errorPayload, compiledVersion ?? 'unknown');
        } catch (e) {}
    }

    private sendData(error, versionInfo?: any) {
        try {
            this.http
                .post(`${environment.apiEndpoint}logging/app`, {
                    app_version: versionInfo,
                    exception: error,
                    url: window?.location?.href,
                })
                .pipe(
                    catchError(err => {
                        return of([]);
                    })
                )
                .subscribe();
        } catch (e) {}
    }
}
